import $ from "jquery";

export function initBasket(){
    $('[data-remove-cart-item]').click(function (event) {
        event.preventDefault();
        const button = $(event.currentTarget);
        const url = button.data('remove-cart-item');

        $.post(
            url,
            {},
            function (response) {
                if (response.success) {
                    pushGAData(response.gaData);
                    window.location.reload();
                } else {
                    alert(response.message);
                }
            },
            'json'
        );
    })

    $('[data-update-cart-item]').click(function (event) {
        event.preventDefault();
        const button = $(event.currentTarget);
        const url = button.data('update-cart-item');
        const parentItem = button.parents('[data-cart-item]');
        const quantity = parentItem.find('[data-update-cart-item-quantity]').val();

        $.post(
            url,
            {quantity},
            function (response) {
                if (response.success) {
                    window.location.reload();
                } else {
                    alert(response.message);
                }
            },
            'json'
        );
    })
    
    $('[data-change-item-fulfilment-method]').click(function (event) {
        event.preventDefault();
        const button = $(event.currentTarget);
        const url = button.data('change-item-fulfilment-method');
        $.post(
            url,
            {},
            function (response) {
                if (response.success) {
                    window.location.reload();
                } else {
                    alert(response.message);
                }
            },
            'json'
        );
    })
}

function pushGAData(data){
    let normalizedData = normalizeCategoryData(data);
    window.dataLayer = window.dataLayer || [];
    dataLayer.push({ecommerce: null});
    dataLayer.push(normalizedData);
}

function normalizeCategoryData(data){
    if (data?.ecommerce.items[0].item_categories.length){
        data.ecommerce.items[0].item_categories.forEach(function(item,index){
            data.ecommerce.items[0][`item_category${(index===0 ? '' : index + 1)}`] = item;
        });
        delete data.ecommerce.items[0].item_categories;
    }
    
    return data;
}